import { gql } from '@apollo/client';

export const FETCH_AI_CREDITS = gql`
  query findRemovebgCredits {
    findRemovebgCredits {
      edges {
        node {
          freeCreditsAmount
          paidCreditsAmount
        }
      }
    }
  }
`;

export const FETCH_AI_CREDITS_ORDERS = gql`
  query findRemovebgCreditsOrders {
    findRemovebgOrders(first: 30, order: createdAt_DESC) {
      edges {
        node {
          objectId
          createdAt
          freeCreditsAmount
          paidCreditsAmount
          note
        }
      }
    }
  }
`;
